import { required, numeric, integer, helpers } from '@vuelidate/validators';
import i18n from "@/plugins/i18n";

export default function (formState) {
  return {
    form: {
      branch_id: {
        required: helpers.withMessage(i18n.global.t('Please select branch.'), required),
        integer: helpers.withMessage(i18n.global.t('Please enter a valid number.'), integer)
      },
      inventory_recipe_id: {
        required: helpers.withMessage(i18n.global.t('Please select a recipe.'), required),
        integer: helpers.withMessage(i18n.global.t('Please enter a valid number.'), integer)
      },
      batch_multiplier: {
        required: helpers.withMessage(i18n.global.t('Please enter a multiplier.'), required),
        numeric: helpers.withMessage(i18n.global.t('Please enter a valid number.'), numeric)
      },
      name: {
        required: helpers.withMessage(i18n.global.t('Please enter a name.'), required)
      },
      planned_total_input_cost: {
        required: helpers.withMessage(i18n.global.t('Please enter a cost.'), required),
        numeric: helpers.withMessage(i18n.global.t('Please enter a valid number for the cost.'), numeric)
      },
      note: {
      },
      inputs: {
        required: helpers.withMessage(i18n.global.t('Please add at least one input.'), required),
        $each: helpers.forEach({
          inventory_id: {
            required: helpers.withMessage(i18n.global.t('Please select an ingredient.'), required),
            integer: helpers.withMessage(i18n.global.t('Please enter a valid number.'), integer)
          },
          planned_quantity: {
            required: helpers.withMessage(i18n.global.t('Please enter a quantity.'), required),
            numeric: helpers.withMessage(i18n.global.t('Please enter a valid number for the quantity.'), numeric)
          },
          planned_cost_per_unit: {
            required: helpers.withMessage(i18n.global.t('Please enter a cost.'), required),
            numeric: helpers.withMessage(i18n.global.t('Please enter a valid number for the cost.'), numeric)
          },
          planned_total_cost: {
            required: helpers.withMessage(i18n.global.t('Please enter a cost.'), required),
            numeric: helpers.withMessage(i18n.global.t('Please enter a valid number for the cost.'), numeric)
          },
          unit_id: {
            required: helpers.withMessage(i18n.global.t('Please select a unit.'), required),
            integer: helpers.withMessage(i18n.global.t('Please enter a valid number.'), integer)
          }
        })
      },
      outputs: {
        required: helpers.withMessage(i18n.global.t('Please add at least one output.'), required),
        $each: helpers.forEach({
          inventory_id: {
            required: helpers.withMessage(i18n.global.t('Please select an ingredient.'), required),
            integer: helpers.withMessage(i18n.global.t('Please enter a valid number.'), integer)
          },
          planned_quantity: {
            required: helpers.withMessage(i18n.global.t('Please enter a quantity.'), required),
            numeric: helpers.withMessage(i18n.global.t('Please enter a valid number for the quantity.'), numeric)
          },
          planned_cost_per_unit: {
            required: helpers.withMessage(i18n.global.t('Please enter a cost.'), required),
            numeric: helpers.withMessage(i18n.global.t('Please enter a valid number for the cost.'), numeric)
          },
          planned_total_cost: {
            required: helpers.withMessage(i18n.global.t('Please enter a cost.'), required),
            numeric: helpers.withMessage(i18n.global.t('Please enter a valid number for the cost.'), numeric)
          },
          unit_id: {
            required: helpers.withMessage(i18n.global.t('Please select a unit.'), required),
            integer: helpers.withMessage(i18n.global.t('Please enter a valid number.'), integer)
          },
          applied_shelf_life_value: {
            required: helpers.withMessage(i18n.global.t('Please enter a shelf life value.'), required),
            integer: helpers.withMessage(i18n.global.t('Please enter a valid number.'), integer)
          },
          applied_shelf_life_unit: {
            required: helpers.withMessage(i18n.global.t('Please select a shelf life unit.'), required)
          }
        })
      }
    }
  }
};
